import React, { ReactElement, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';

export interface AnimateProps {
  on: boolean;
  className?: string;
  children: ReactElement;
}

export default function Shake({
  on,
  className,
  children,
}: AnimateProps): ReactElement {
  const [interpolate, setInterpolate] = useState({
    range: [0, 0],
    output: [0, 0],
  });
  const { x } = useSpring({
    from: { x: 0 },
    x: on ? 1 : 0,
    config: { duration: 1000 },
  });

  useEffect(() => {
    const shake = {
      range: [0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1],
      output: [0, -5, 5, -5, 5, -5, 5, 0],
    };
    const noShake = { range: [0, 0], output: [0, 0] };
    setInterpolate(on ? shake : noShake);
  }, [on]);
  return (
    <animated.div
      className={className}
      style={{
        transform: x
          .interpolate(interpolate)
          .interpolate((x: number) => `translateX(${x}px)`),
      }}
    >
      {children}
    </animated.div>
  );
}
